export const MODAL_WIDTH = 920;
export const MODAL_GAP = 68;
